import React from "react";
import Select from "react-select";
import "../styles/DropdownColumnFilterStudent.css";

const DropdownColumnFilterStudent = ({ column, onFilterChange }) => {
  const { filterValue, setFilter, preFilteredRows, id, label } = column;

  // Fallback labels for callers that don't pass one explicitly.
  const fieldLabels = {
    name: "Student Name",
    batch: "Batch",
    city: "City",
    course: "Course",
    feedbackCount: "Feedback Count",
  };

  const options = React.useMemo(() => {
    const unique = new Set();
    preFilteredRows.forEach((row) => {
      unique.add(row.values[id]);
    });

    return Array.from(unique).map((val) => ({
      value: val,
      label: String(val),
    }));
  }, [id, preFilteredRows]);

  const handleChange = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : undefined;
    setFilter(newValue);
    if (onFilterChange) {
      onFilterChange(id, newValue); // Notify parent component
    }
  };

  const defaultValue = filterValue
    ? { label: filterValue, value: filterValue }
    : null;

  return (
    <div className="student-dropdown-column-row">
      <label className="student-dropdown-column-label">
        Filter by
      </label>
      <Select
        options={options}
        isClearable
        value={defaultValue}
        onChange={handleChange}
        placeholder={label || fieldLabels[id] || id}
        isSearchable
        className="student-dropdown-column-filter"
        classNamePrefix="dropdown"
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
};

export default DropdownColumnFilterStudent;
